module.exports = __webpack_public_path__ + "static/assets/6f84321df76a8368b11ba90f7bbaf464.png";